<template>
  <div class="page-container">
    
    <div class="data-filter">
      <el-radio-group v-model="pagination.filter" size="mini"  @change="filterHandler">
        <el-radio-button :label="null">필터없음</el-radio-button>
        <el-radio-button :label="1">금액이 0 이상인 결제</el-radio-button>
        <el-radio-button :label="2">금액이 0인 결제</el-radio-button>
        <el-radio-button :label="3">LG 결제</el-radio-button>
        <el-radio-button :label="4">관리자 수동 결제</el-radio-button>
      </el-radio-group>
    </div>

    <div class="data-table">
      <el-table class="lmm-table" :data="list" v-loading="loading" stripe border>
        <el-table-column type="index" :index="rowIndex" width="120"></el-table-column>
        <el-table-column label="날짜" width="180">
          <template slot-scope="scope">{{ scope.row.payment.create_time | moment('YYYY-MM-DD HH:mm:ss') }}</template>
        </el-table-column>
        <el-table-column label="결제수단" width="120">
          <template slot-scope="scope">{{ $service.getPaymentMethod('value', scope.row.payment.payment_method).name }}</template>
        </el-table-column>
        <el-table-column label="금액" width="180">
          <template slot-scope="scope">{{ scope.row.payment.price | currency('₩', 0) }}</template>
        </el-table-column>
        <el-table-column label="회사이름">
          <template slot-scope="scope">
            <router-link 
              class="el-link el-link--info is-underline" 
              :to="{
                name: 'management-detail', 
                params: {company_pk: scope.row.company.pk, back: { name: $route.name, pagination }}}">
              <span v-if="scope.row.company.company_name">{{ scope.row.company.company_name }}</span>
              <span v-else class="dimmed-text">개인 사용자</span>
              <span>&nbsp;( {{scope.row.company.manager_name}} )</span>
            </router-link>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="data-pagination">
      <el-pagination
        layout="prev, pager, next"
        :total="pagination.total"
        :current-page.sync="pagination.page"
        @current-change="pageHandler">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    async getPayment () {
      console.log('GET PAYMENT')
      try {
        this.loading = true
        let params = { offset: this.pagination.offset, limit: this.pagination.limit, filter: this.pagination.filter }

        let response = await this.$http.get('payment', {params})
        this.pagination.total = response.data.total
        this.list = response.data.list
        
        this.loading = false
        return response
      }
      catch (e) {
        console.error(e)
      }
    },
    rowIndex (index) {
      let {total, offset} = this.pagination
      return total - (offset + index)
    },
    pageHandler (page) {
      this.pagination.offset = this.pagination.limit * (page - 1)
      this.getPayment()
    },
    filterHandler () {
      this.getPayment()
    }
  },
  mounted () {
    if (this.$route.params.restore) {
      this.pagination.total = this.$route.params.restore.pagination.total
      this.pagination.limit = this.$route.params.restore.pagination.limit
      this.pagination.offset = this.$route.params.restore.pagination.offset
      this.pagination.page = this.$route.params.restore.pagination.page
      this.pagination.filter = this.$route.params.restore.pagination.filter
    }
    this.getPayment()
  },
  data () {
    return {
      loading: false,
      search: null,
      pagination: {
        total: 0,
        limit: 10,
        offset: 0,
        page: 1,
        filter: 1
      },
      list: []
    }
  }
}
</script>

<style lang="scss" scoped>
.manager-information {
  list-style: none;
  padding: 0; margin: 0;

  > li {
    padding: 4px 10px;
    > div { display: inline-block; }
    > .label {
      width: 160px;
      color: #a0a0a0;
    }
  }
}
.data-pagination {
  text-align: center;
  background-color: white;
  padding: 4px 10px;
}

.data-filter {
  padding: 10px 0;
  .data-filter-buttons {
    display: inline-block;
  }
  .data-filter-search {
    display: inline-block;
    padding-left: 15px;
  }
}
</style>
